/**
 * Shared input type for every formatter in this module.
 *
 * Accepts what callers actually have in hand:
 *   - `string` for ISO timestamps and API responses
 *   - `number` for epoch milliseconds (Date.now(), stored timestamps)
 *   - `Date` for already-parsed values
 *   - `null` / `undefined` for missing data (fallback path)
 */
export type DateInput = string | number | Date | null | undefined;

/**
 * Coerce a `DateInput` to a `Date`. Returns `null` if the input is
 * nullish, an empty string, or doesn't produce a valid date.
 */
export function toDate(value: DateInput): Date | null {
  if (value === null || value === undefined) return null;
  if (value === '') return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}
